import React from "react";
import logo from "assets/logo_cnr.svg";
import { FooterContainer } from "./Footer.styled";
import { Paragraph } from "components/Text";

const Footer = () => {
  return (
    <FooterContainer className="content-always-on-display">
      <div className="container">
        <div className="line"></div>
        <div className="row">
          <div className="col-md-6 a11y-fonts-col-12">
            <img className="mb-3" src={logo} height={100} alt="Logo CNR" />
            <Paragraph>
              Somos un servicio que se creó en septiembre de 1975, tenemos
              calidad de persona jurídica y nuestro principal objetivo es
              asegurar el incremento y mejoramiento de la superficie regada del
              país.
            </Paragraph>
            <Paragraph>Esta plataforma es administrada:</Paragraph>
            <a className="py-0" href="https://www.cnr.gob.cl">
              <Paragraph>www.cnr.gob.cl</Paragraph>
            </a>
            <Paragraph>© {new Date().getFullYear()} Registro de Consultores</Paragraph>
          </div>
          <div className="col-md-6 a11y-fonts-col-12">
            <div className="text-uppercase mb-3">
              <Paragraph>Redes sociales</Paragraph>
            </div>
            <div className="d-flex">
              <div className="col">
                <a href="https://www.instagram.com/cnrchile/?hl=es" aria-label="Instagram">
                  <i className="cl cl-instagram cl-social"/>
                </a>
              </div>
              <div className="col">
                <a href="https://www.facebook.com/CNRCHILE/?locale=es_LA" aria-label="Facebook">
                  <i className="cl cl-facebook cl-social"></i>
                </a>
              </div>
              <div className="col">
                <a href="https://www.youtube.com/channel/UCkVKiZ7F-56J0OmRSMo-SpQ" aria-label="Youtube">
                  <i className="cl cl-youtube cl-social"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </FooterContainer>
  );
};

export default Footer;
